<template>
  <div class="navbar-orgin" :style="{ width: ((config.orgW) || 320) + 'px' }">
    <div class="navbar-orgin-search">
      <div class="input-box">
        <el-input placeholder="请输入关键词" v-model="searchOrigina" @keydown.enter="goSearchOrigina"></el-input>
      </div>
      <div class="iocn" @click="goSearchOrigina">
        <el-icon>
          <Search />
        </el-icon>
      </div>
    </div>
    <div class="navbar-orgin-tools" :style="{ justifyContent: isAppenGraduation ? 'space-between' : 'flex-end' }">
      <div class="tools-check" v-if="isAppenGraduation">
        <el-checkbox v-model="isGraduation" @change="changeGraduation">显示已毕业</el-checkbox>
      </div>
      <div class="tools-close" @click="dealOrginClose">
        <i class="iconfont icon-a-24shouqizhankai" :style="{ transform: isOrgOpen ? '' : 'rotate(180deg)' }"></i>
        <span class="text">{{ isOrgOpen ? '收起' : '展开' }}</span>
      </div>
    </div>
    <div class="navbar-orgin-tree" v-show="!isOrginSearch">
      <el-tree highlight-current v-if="orgList.length !== 0" :current-node-key="currentOrg.id" ref="orgTree" :key="treeKey" :load="loadCustomNode" lazy :props="props" node-key="organizationId" highlight-curren :expand-on-click-node="false" :default-expanded-keys="defaultShowNodes" @node-click="treeToSearch">
        <template #default="{ node, data }">
          <span class="custom-tree-node">
            <span class="line" v-show="node.level !== 1"></span>
            <template v-if="data.userId">
              <div class="user-sex-icon" :style="{ background: data.sex === 0 ? '#5DA7FF' : data.sex === 1 ? '#FFA3B9' : '' }">
                <el-icon v-if="data.sex === 0">
                  <Male />
                </el-icon>
                <el-icon v-else-if="data.sex === 1">
                  <Female />
                </el-icon>
              </div>
              <span style="margin-left: 5px;">{{ data.name }}</span>
            </template>
            <template v-else>
              <el-tooltip effect="dark" :content="node.label" placement="top">
                <span :style="[getColor(node.data.organizationId), { flex: config.orgTag === 'open' ? '0.9' : '1' }]" class="orgin-text" >{{ dealShowName(data) }}</span>
              </el-tooltip>
              <template v-if="config.orgTag === 'open'">
                <span v-if="dealType(data.type)"
                  :style="{ color: labelView({val: data.type, type: 'color'}), backgroundColor: labelView({val: data.type, type: 'background'}) }" class="none-type">
                  {{ dealType(data.type) }}
                </span>
                <span class="none-type" v-else>无类型</span>
              </template>
            </template>
          </span>
        </template>
      </el-tree>
    </div>
    <ul v-show="isOrginSearch" class="orgin-search">
      <li @click="treeToSearch(item)" v-for="item in originaList" class="orgin-search-item" :key="item.organizationId">
        {{ dealShowName(item) }}
      </li>
    </ul>
  </div>
</template>

<script>

import colorType from '@/components/common/multipleChoice/color'
import { getOrgShowName } from "@/api/global";
import { getBottomLayerId, generateTreeDataWithSorting, treeExpandOrFold, filterTreeByIds } from '@/components/schoolInstrument/mixins/utils'

import { getopenuserlist } from '@/port/clientSide/multipleChoice'
import { getbespeakorganizationList } from '@/port/clientSide/workbench'
import { getdeptlist, getdeptalllist } from '@/port/schoolInstrument/appConfig'
import { cloneDeep } from 'lodash';
import { toRaw } from 'vue';
export default {
  // 组件名称
  name: 'organizationList',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    isDoor: {
      type: Boolean,
      default: false
    },
    organizationType: {
      type: Array,
      default: () => []
    },
    isGetData: {
      type: Boolean,
      default: true
    }
  },
  // 组件状态值
  data () {
    return {
      defaultShowNodes: [],
      isOrgOpen: false,
      orgList: [],
      props: {
        label: 'name',
        isLeaf: 'leaf'
      },
      isAppenGraduation: false,
      totalOrgList: [],
      searchOrigina: '',
      isOrginSearch: false,
      isGraduation: false,
      originaList: [],
      currentOrg: {},
      activeOrgan: '',
      treeKey: 0
    }
  },
  // 计算属性
  computed: {
    isShowLastUser() {
      return this.config.showLastUser === 'open'
    },
    // 是否开了分级管理
    isGradedManagement () {
      return this.config.administrationOrg === 'open'
    }
  },
  created () {
    if (!this.isGradedManagement) this.getOrgList()
    else this.getOrgListByAdmin()
  },
  // 侦听器
  watch: {
    orgList: {
      handler(val) {
        this.$emit('setOrgList', val)
      },
      immediate: true,
      deep: true
    },
    currentOrg: {
      handler(val) {
        this.$emit('setCurrentOrg', val)
      },
      immediate: true,
      deep: true
    }
  },
  // 组件方法
  methods: {
    getFilterLi(val) {
      let li = cloneDeep(val)
      let bespeakdeptids = []
      if (this.isGradedManagement) {
        bespeakdeptids = this.config.activeTreeArr || []
      } else {
        bespeakdeptids = this.config.filterTreeArr || []
      }
      li = filterTreeByIds(li, toRaw(bespeakdeptids), { children: 'children', id: 'organizationId' })
      return li
    },
    dealOrginClose() {
      const isOrgOpen = !this.isOrgOpen
      let treeRef = this.$refs.orgTree
      treeExpandOrFold(treeRef, isOrgOpen)
      this.isOrgOpen = !this.isOrgOpen
    },
    async loadCustomNode(node, resolve) {
      if (node.level === 0) {
        let li = this.orgList
        let bespeakdeptids = []
        if (this.isGradedManagement) {
          bespeakdeptids = this.config.activeTreeArr || []
        } else {
          bespeakdeptids = this.config.filterTreeArr || []
        }
        if (bespeakdeptids.length !== 0) {
          const idx = li.findIndex(c => bespeakdeptids.findIndex(f => f === c.organizationId) !== -1)
          // const flag = this.isGradedManagement ? idx === -1 : idx !== -1
          const flag = idx !== -1
          if (flag) {
            li = li.filter(c => bespeakdeptids.findIndex(f => f === c.organizationId) !== -1)
          }
        }
        resolve(li)
      } else {
        if (node.data.children.length === 0 && this.isShowLastUser) {
          const param = {
            curpage: 0,
            pagesize: 0,
            organizationId: node.data.organizationId
          }
          const { code, data } = await getopenuserlist(param)
          if (code === 0) {
            const _data = data.map(item=>{
              return {
                ...item,
                leaf: true,
                name: item.realname,
              }
            })
            resolve(_data)
          } else {
            resolve([])
          }
        } else {
          let li = node.data.children.map(item=>{
            if (item.children && item.children.length > 0) {
              return {
                ...item,
                leaf: false
              }
            } else if (this.isShowLastUser && item.children && item.children.length === 0) {
              return {
                ...item,
                leaf: false
              }
            } else {
              return {
                ...item,
                leaf: true
              }
            }
          })
          let bespeakdeptids = []
          if (this.isGradedManagement) {
            bespeakdeptids = this.config.activeTreeArr || []
          } else {
            bespeakdeptids = this.config.filterTreeArr || []
          }
          if (bespeakdeptids.length !== 0) {
            const idx = li.findIndex(c => bespeakdeptids.findIndex(f => f === c.organizationId) !== -1)
            const flag = idx !== -1
            if (flag) {
              li = li.filter(c => bespeakdeptids.findIndex(f => f === c.organizationId) !== -1)
            }
          }
          resolve(li)
        }
      }
    },
    async goSearchOrigina(){
      if (this.searchOrigina === '') {
        this.isOrginSearch = false
      } else {
        const total = this.totalOrgList
        let li = []
        if (this.isGraduation) {
          li = this.totalOrgList.filter(c => getOrgShowName(c).includes(this.searchOrigina))
        } else {
          li = total.filter(item => !(getOrgShowName(item).includes('(已毕业)'))).filter(c => getOrgShowName(c).includes(this.searchOrigina))
        }
        this.originaList = li
        this.isOrginSearch = true
      }
    },
    changeGraduation (val) {
      const bespeakdeptids = this.config.activeTreeArr || []
      const isAppenSubordinate = this.config.isAppenSubordinate === undefined ? true : this.config.isAppenSubordinate
      const { tree } = generateTreeDataWithSorting({ data: this.totalOrgList, isFilter: !val, isAppenSubordinate, bespeakdeptids, isShowLastUser: this.isShowLastUser })
      this.orgList = this.getFilterLi(tree)
      const treeRef = this.$refs.orgTree
      this.treeKey++
      this.$nextTick(() => {
        treeExpandOrFold(treeRef, false)
        this.isOrgOpen = false
      })
    },
    async getOrgList() {
      const bespeakdeptids = this.config.activeTreeArr || []
      const isAppenSubordinate = this.config.isAppenSubordinate === undefined ? true : this.config.isAppenSubordinate
      const params = {
        bespeakdeptids,
        curpage: 0,
        pagesize: 0
      }
      const res = await getbespeakorganizationList(params)
      if (res.code === 0) {
        if (res.data[0] && res.data[0].organizationId === undefined) {
          res.data = res.data.map(item => {
            return {
              ...item,
              organizationId: item.organizationid
            }
          })
        }
        this.totalOrgList = res.data
        const { tree, isAppenGraduation } = generateTreeDataWithSorting({ data: this.totalOrgList, isFilter: !this.isGraduation, bespeakdeptids, isAppenSubordinate, isShowLastUser: this.isShowLastUser })
        this.isAppenGraduation = isAppenGraduation
        this.orgList = this.getFilterLi(tree)
        this.defaultShowNodes.push(tree[0].organizationId)
        this.treeToSearch(this.orgList[0], this.isGetData)
      }
    },
    async getOrgListByAdmin() {
      const param = {
        curpage: 0,
        pagesize: 0,
        pid: -2
      }
      if (this.spaceid) {
        param.spaceid = this.spaceid
      } else if (this.upaceid) {
        param.upaceid = this.upaceid
      }
      const isAppenSubordinate = this.config.isAppenSubordinate === undefined ? true : this.config.isAppenSubordinate
      const res = await this.getOrginList(param)
      if (res.length !== 0) {
        this.totalOrgList = res
        const { tree, isAppenGraduation } = generateTreeDataWithSorting({ data: this.totalOrgList, isFilter: !this.isGraduation, isAppenSubordinate, isShowLastUser: this.isShowLastUser })
        this.isAppenGraduation = isAppenGraduation
        this.orgList = this.getFilterLi(tree)
        this.defaultShowNodes.push(tree[0].organizationId)
        this.treeToSearch(this.orgList[0], this.isGetData)
      }
      
    },
    async getOrginList (obj) {
      const { code, data } = await getdeptlist(obj)
      const { code: code1, data: data1 } = await getdeptalllist(obj)
      if (code === 0 && code1 === 0) {
        for (const ele of data1) {
          const idx = data.findIndex(c => c.organizationId === ele.organizationId)
          if (idx !== -1) {
            ele.pid = 0
          }
        }
        if (this.config.showLastUser === 'open') return data1
        let res = data1.map(item => {
          return {
            ...item,
            leaf: !item.lst
          }
        })
        return res
      } else{
        return []
      }
    },
    treeToSearch(data, isGet = true) {
      if (this.isDoor) {
        this.currentOrg = {
          id: data.organizationId || data.organizationid,
          name: data.name,
          looktype: data.looktype,
          type: data.type
        }
        this.$emit('treeToSearch', data, isGet)
      } else {
        const filed = this.config.filterFieldsValue
        let objItem = ''
        let value = {}
        const type = this.config.orgType
        if (type === 'userId') {
          objItem = filed
        } else if (type === 'orgId') {
          objItem = this.config.orgId
        } else if (type === 'orgName') {
          objItem = this.config.orgName
        } else {
          objItem = filed
        }
        if (objItem) {
          value = getBottomLayerId({ data, type: type === 'orgName' ? 'name' : 'id', isChildren: this.isGradedManagement })
          if (objItem.includes('organization') || objItem.includes('relation-user')) {
            value = getBottomLayerId({ data, type: 'org' })
          }
        }
        let currentOrg = {}
        if (data) {
          this.currentOrg = {
            id: data.organizationId || data.organizationid,
            name: data.name,
            looktype: data.looktype,
            type: data.type
          }
          this.activeOrgan = currentOrg.id
        }
        this.$emit('treeToSearch', value)
      }
    },
    dealShowName (data) {
      return getOrgShowName(data)
    },
    dealType (type) {
      const itype = this.organizationType.find(item => item.deptTipId === type) || {}
      return itype.name
    },
    isActiveTree (id) {
      let flag = false
      if (this.config.activeTreeArr) {
        this.config.activeTreeArr.forEach(item => {
          if (item === id) {
            flag = true
          }
        })
      }
      return flag
    },
    toHideOrShow (data) {
      if (!this.config.activeTreeArr) {
        this.$set(this.config, 'activeTreeArr', [])
      }
      const idx = this.config.activeTreeArr.findIndex(item => item === data.organizationId)
      if (idx === -1) {
        // eslint-disable-next-line vue/no-mutating-props
        this.config.activeTreeArr.push(data.organizationId)
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.config.activeTreeArr.splice(idx, 1)
      }
    },
    getColor (key) {
      return this.activeOrgan && this.activeOrgan === key ? 'color:#4e86ff' : ''
    },
    labelView ({ val, type }) {
      const itype = this.organizationType.find(item => item.deptTipId === val) || {}
      if (itype.deptTipId > 9) {
        return colorType[itype.colours] && colorType[itype.colours][type]
      } else {
        return colorType[itype.deptTipId] && colorType[itype.deptTipId][type]
      }
    }
  }
}
</script>

<style scoped lang="scss">

.navbar-orgin {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-right: 1px #eee solid;
  margin-right: 10px;
  padding: 20px 0;
  box-sizing: border-box;
  flex-shrink: 0;
  &-tools {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    margin-bottom: 5px;
    .tools-close {
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        transition: .3s;
        display: inline-block;
      }
    }
  }
  &-search {
    position: relative;
    margin-bottom: 16px;
    padding: 0 8px;
    width: 90%;
    .input-box {
      height: 32px;
      width: 100%;

      ::v-deep .el-input {
        border-radius: 23px;
      }
      ::v-deep .el-input .el-input__wrapper {
        background: #f7f9fa;
        border: none;
        height: 32px;
        padding-right: 30px;
        border-radius: 23px;
        box-shadow: none;
      }
    }
    .iocn {
      position: absolute;
      top: 0;
      right: 8px;
      background-color: #38a2fb;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        color: #ffffff;
      }
    }
  }
  &-tree {
    height: 780px;
    overflow-x: hidden;
    width: 100%;
    .custom-tree-node{
      display: flex;
      align-items: center;
      position: relative;
      .orgin-text{
        display: inline-block;
        width: 188px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .user-sex-icon {
        width: 12px;
        height: 12px;
        border-radius: 2px;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          color: #fff;
          font-size: 10px;
        }
      }
      .none-type {
        background-color: rgba(225,230,235,0.5);
        color: #adb0b2;
        display: inline-block;
        padding: 4px 10px;
        text-align: center;
        border-radius: 4px;
        margin-left: 8px;
      }
  }
  ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: rgba(54, 162, 251, 0.1);
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
      background-color: #36A2FB;
    }
  }
  ::v-deep .el-tree-node__content{
    height: 28px;
    .line{
        position: absolute;
        display: block;
        left: -32px;
        bottom: 12px;
        width: 13px;
        height: 500px;
        border-left: 1px solid #DDEDFB;
        border-bottom: 1px solid #DDEDFB;
      }
    }
    &-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      .tree-icon{
        margin-right: 8px;
        cursor: pointer;
      }
    }
  }
  .orgin-search{
    height: 780px;
    overflow-x: hidden;
    width: 100%;
    &-item {
      height: 40px;
      line-height: 40px;
      padding-left: 16px;
      cursor: pointer;
      &:hover {
        background: #f7f9fa;
        font-weight: 500;
        color: #38a2fb;
      }
    }
  }
}
</style>
